var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Prop, Emit, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { Dependencies } from '~/core/decorator';
import { FileUploadService } from "~/services/file-service/file-upload.service";
var EnclosureList = /** @class */ (function (_super) {
    __extends(EnclosureList, _super);
    function EnclosureList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileDataSet = [];
        _this.srcList = [];
        return _this;
    }
    EnclosureList.prototype.emitClose = function () { };
    EnclosureList.prototype.onfileIdsChange = function (val) {
        var _this = this;
        this.fileDataSet = [];
        if (val)
            this.fileUploadService.getAllUploadFileByIds([val]).subscribe(function (data) {
                _this.fileDataSet = data;
                _this.fileDataSet.forEach(function (item) {
                    _this.srcList.push(item.url);
                });
            });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], EnclosureList.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], EnclosureList.prototype, "fileUploadService", void 0);
    __decorate([
        Prop({
            required: true,
            type: String
        })
    ], EnclosureList.prototype, "fileIds", void 0);
    __decorate([
        Emit("close")
    ], EnclosureList.prototype, "emitClose", null);
    __decorate([
        Watch("fileIds", { immediate: true })
    ], EnclosureList.prototype, "onfileIdsChange", null);
    EnclosureList = __decorate([
        Component({
            components: {}
        })
    ], EnclosureList);
    return EnclosureList;
}(Vue));
export default EnclosureList;
